const skuRemap: Record<string, { base: string; addon: string[] }> = {
	reg: {
		base: "standard",
		addon: [],
	},
	grad: {
		base: "standard",
		addon: ["graduation cap"],
	},
};

// Addons follow the shape:
// GRAPHIC-BODY+FILLING|ADDONN

type graphic = `${string}-`;
type base = string;
type addon = `+${string}`;
type sku = `${graphic | ""}${base}${addon | ""}`;

const normalizeSkuToken = (value: string): string => value.trim().toUpperCase();

export const splitSku = (sku: sku): { base: string; addon: string[] } => {
	const normalizedSku = sku.trim();
	const match = normalizedSku.match(/^(?<graphic>(?:.*-)?)(?<base>[^+]+?)(?:\+(?<addon>.+))?$/i);

	if (!match?.groups) {
		const remapped = skuRemap[normalizedSku.toLowerCase()];
		if (!remapped) {
			return { base: normalizeSkuToken(normalizedSku), addon: [] };
		}

		return {
			base: normalizeSkuToken(remapped.base),
			addon: remapped.addon.map(normalizeSkuToken),
		};
	}

	const { base: matchedBase, addon: matchedAddon } = match.groups;
	const remapped = skuRemap[matchedBase.toLowerCase()];
	const baseAddon = remapped?.addon ?? (matchedAddon ? [] : []);
	const inlineAddon = matchedAddon ? [matchedAddon] : [];

	return {
		base: normalizeSkuToken(remapped?.base ?? matchedBase.trim()),
		addon: [...baseAddon, ...inlineAddon].map(normalizeSkuToken),
	};
};
